import { FC } from 'react';

import { GridLayout, VSpacing } from '@hh.ru/magritte-ui';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import { ModerationReasonsList } from 'components/Admin/ModerationReasonsList/ModerationReasonsList';
import Nav from 'components/Admin/Nav/Nav';

export const ModerationReasonsListPage: FC = () => (
    <>
        <AdminHeader />
        <GridLayout>
            <VSpacing default={24} />
            <Nav />
            <ModerationReasonsList />
        </GridLayout>
    </>
);
